// src/components/ProtectedRoute.jsx
import React, { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import LoginModal from './auth/LoginModal';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    // You can show a loading spinner
    return <div>Loading...</div>;
  }

  if (!user) {
    // Show a login paywall (a modal in this case)
    return <LoginModal />;
  }

  // If user is authenticated, render children
  return children;
}
